import type { ReactElement } from 'react';

import { ensureDefined } from '@e-socna/utils';
import { RESOLVER_CONTENT_CLASSNAME } from '@e-socna/printer-contract';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { useQuotationContact } from './hooks/useQuotationContact.hook';

export const useDevisPolitesseOutro = (
  parameters: ResolverParameters,
): ResolverResult<ReactElement> => {
  const recipient = useQuotationContact(parameters);

  if (!recipient.isSuccess) {
    return {
      ...recipient,
      data: undefined,
    };
  }

  const {
    data: { civility },
  } = ensureDefined({
    data: recipient.data,
  });

  const content = (
    <div className={RESOLVER_CONTENT_CLASSNAME}>
      <p>
        Souhaitant avoir répondu à votre attente,
        <br />
        Nous vous prions d&apos;agréer, {civility.label}, l&apos;expression de
        nos salutations distinguées.
      </p>
    </div>
  );

  return {
    data: { generated: content },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
